import styled, { css } from "styled-components";
import { MarketingButton } from "screens/Homepage/styles";

export type TUnit = "h" | "m" | "s";

interface IProps {
  unit?: TUnit;
  onUnitChange?: (newUnit: TUnit) => void;
}

const RateUnitSelect: React.FC<IProps> = ({ unit: currentUnit, onUnitChange }) => {
  const onClick = (unit: TUnit) => {
    return (event: React.MouseEvent<HTMLButtonElement>) => {
      onUnitChange && onUnitChange(unit);
    };
  };

  const renderButton = (label: string, unit: TUnit) => {
    if (currentUnit === unit) {
      return <ActiveTabButton>{label}</ActiveTabButton>;
    }
    return <InactiveTabButton onClick={onClick(unit)}>{label}</InactiveTabButton>;
  };

  return (
    <Container>
      {renderButton("Per Second", "s")}
      {/* {renderButton("Per Minute", "m")} */}
      {renderButton("Per Hour", "h")}
    </Container>
  );
};

export default RateUnitSelect;

const Container = styled.div`
  ${({ theme }) => {
    return css`
      position: absolute;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 4px;
      box-sizing: border-box;
      gap: 2px;
      background-color: ${theme.colors.gray3};
      border: 1px solid ${theme.colors.gray7};
      box-shadow: ${theme.shadows.base};
      border-radius: 8px;
      bottom: -25px;
      @media (max-width: ${theme.breakpoints.sm}px) {
        bottom: -22px;
      }
    `;
  }}
`;

const TabButtonCSS = css`
  && {
    ${({ theme }) => {
      return css`
        color: ${theme.colors.gray12};
        height: 40px;
        ${theme.styleSet.textBasePlus};

        @media (max-width: ${theme.breakpoints.sm}px) {
          ${theme.styleSet.textSmPlus};
          height: 36px;
        }
      `;
    }}
  }
`;

const InactiveTabButton = styled(MarketingButton).attrs({
  buttonTheme: "secondary",
  variant: "ghost",
})`
  ${TabButtonCSS};
`;

const ActiveTabButton = styled(MarketingButton)`
  ${TabButtonCSS};
`;
